import "../theme/AdministracionCatalogo.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableAdministracionModeloATB } from "../components/TableAdministracionModeloATB";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageModeloATB = () => {
  const authProvider = useDynamicAuth(); // Usar el hook

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>
              <TableAdministracionModeloATB />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
